import { Dimensions, Image, Linking, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { fp, spH, spV, wp, hp } from "utils/normalizeV2";
import { memo, useCallback, useRef, useState } from "react";
import { useLocalSearchParams } from "expo-router";
import Buttons from "components/Buttons";
import { Colors } from "colors";
import VText from "components/VText";

import { useRouter } from "expo-router";
const { width } = Dimensions.get("screen");


const HomePreferencesBanner= ({ data, gender }) => {
    const router = useRouter();
    // const local = useLocalSearchParams();
    // const gender = local?.gender || "female";

    return (
        <View style={{backgroundColor: "#E4E4E4", height: hp(240),marginBottom: spV(20), paddingHorizontal: spH(50), paddingVertical: spV(30)}}>
            
                <View style={{ flex: 1, justifyContent: "center", alignItems: "center", flexDirection: "row", gap: spH(10) }}>
                    <View style={{width: wp(900)}}>
                    <VText style={{fontSize: fp(24),fontFamily: "LibreBodoni", fontWeight: "300", color: Colors.black,fontStyle: "italic",lineHeight: fp(30),textAlign: "left",width: wp(550)}}>
                             Welcome to your personalized product feed of pieces and looks custom-curated to fit your style
                    </VText>

                    </View>
                    <Buttons   containerStyle={{backgroundColor: Colors.white, width: wp(400), height: hp(50)}} text="Set Preferences" textStyle={{color: Colors.black, fontSize: fp(22), fontFamily: "JosefinSans", fontWeight: "300",}} onPress={() => {
                        router.push(`/my-preferences?gender=${gender}`);
                    }} />


                </View>
        </View>
    );
};


export default memo(HomePreferencesBanner);

